import { BaseConfig } from "../config.interface";
import { Validate } from "../util";

interface ICheckboxConfig {
    label?: string;
    group?: string;
    binary?: boolean;
    validate: Validate;
}


export class CheckboxConfig extends BaseConfig<ICheckboxConfig> implements ICheckboxConfig {
    /**
     * Label of the element.
     */
    label?: string;
    /**
     * Group multiple checkboxes into one group. Accessibility.
     */
    group?: string;
    /**
     * binary or tri-state
     */
    binary?: boolean;
    /**
     * Show validation status already in `pristine` state or after it has been marked as `dirty`.
     */
    validate: Validate;

    /**
     * @theme Base
     */
    static baseTheme = {
        /**
         * Default configuration. 
         * Binary values only.
         * Only allows singular value.
         */
        Default: new CheckboxConfig({
            binary:   true,
            validate: "dirty"
        }),
        /**
         * Allows multi value selection.
         */
        MultiValue: new CheckboxConfig({
            binary:   false,
            validate: "dirty"
        }),
    };
}
